import Image from "next/image";

import { Box } from "@/components/core";
import gif from "../../../../public/gif.gif";

export function Loading() {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "auto",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Image src={gif} alt="Loading gif" width={120} height={120} />
    </Box>
  );
}
